const booter = require('../booter')
const globalMap = require('../globalMap')

function main (config) {
  globalMap.init(config)
}

window.profiles = {
  map: (config) => {
    booter.boot(main.bind(main, config))
  }
}
